var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import Dots from './dots';
import List from './list';
import { transform } from '../../../utils';
const raf = require('raf');
const sliderTmpl = (item) => {
    return (React.createElement("div", { className: styles.swiper_item },
        React.createElement("img", { src: item.src })));
};
const dotTmpl = (current, total) => {
    return React.createElement(React.Fragment, null);
};
const fn = (current, total) => {
    return;
};
/**
 * @param{Boolean} dots 是否有导航 默认 true
 * @param{Boolean} autoplay 是否自动播放 默认 true
 * @param{Number} autoplayInterval 自动播放时间间隔(单位毫秒)，默认 4000
 * @param{Boolean} infinite 是否循环滚动，默认为true，如果允许autoplay，则直接取true
 * @param{String} direction 自动播放时滚动的方向 默认 forward (forward 水平滚动的时候，为从左向右，垂直滚动的时候，为从下到上 reverse 水平滚动的时候，为从右向左，垂直滚动的时候，为从上到下)
 * @param{String} axis 滚动轴 默认为 horizonta 水平 （horizonta 水平 vertical 垂直）
 * @param{Number} initialSlide 初始显示 slider 对应的 current，默认 0
 * @param{Number} unitSize 一个 slider 的单位尺寸 默认 0，如果为 0 时，在组件didmount以后，会根据当前容器进行一次获取
 * @param{Number} padding 一个 slider 距离屏幕两侧的总距离，默认 0
 * @param{Number} reboundWidth 当滑动距离小于此数值时会有回弹效果 默认 0
 * @param{Number} autoplaySpeed 自动播放滚动速度(每帧移动距离) 默认 10，数值超过 unitSize 实际值时呈现无动画切换效果
 * @param{Number} slideSpeed 滑动滚动速度(每帧移动距离) 默认 10，数值超过 unitSize 实际值时呈现无动画切换效果
 * @param{Number} reboundSpeed 回弹滑动滚动速度(每帧移动距离) 默认 10，数值超过 reboundWidth 值时呈现无动画切换效果
 * @param{Function} sliderTmpl 滑块的模板函数，默认有一个，不过需要传入特定结构的数据，会生成特定的html结构
 * @param{Function} dotTmpl dot的模板函数，默认有一个，是特定的html结构
 * @param{Function} touchStart 手指触及轮播图的回调函数，传入两个参数 (currentIndex, total)
 * @param{Function} touchMove 手指滑动的回调函数，传入两个参数 (currentIndex, total)
 * @param{Function} touchEnd 手指离开屏幕时的回调函数，传入两个参数 (currentIndex, total)
 * @param{Function} afterSlide 滑动完成时的回调函数，传入两个参数 (currentIndex, total)
 * @param{Function} beforeAutoplay 自动播放开始时的回调函数，传入两个参数 (currentIndex, total)
 * @param{Function} afterAutoplay 自动播放完成时的回调函数，传入两个参数 (currentIndex, total)
 */
const defaultConfig = {
    dots: true,
    autoplay: true,
    autoplayInterval: 4000,
    infinite: true,
    direction: 'forward',
    axis: 'horizonta',
    initialSlide: 0,
    unitSize: 0,
    padding: 0,
    reboundWidth: 0,
    autoplaySpeed: 20,
    slideSpeed: 20,
    reboundSpeed: 20,
    sliderTmpl,
    dotTmpl,
    touchStart: fn,
    touchMove: fn,
    touchEnd: fn,
    afterSlide: fn,
    beforeAutoplay: fn,
    afterAutoplay: fn,
};
class Slides extends React.PureComponent {
    constructor(props) {
        super(props);
        this.config = Object.assign({}, defaultConfig, this.props.config);
        this.state = {
            initMove: 0,
            move: 0,
            current: 0,
        };
        // 浏览器失焦及聚焦操作
        this.handleVisibilityChange = () => {
            const { autoplay, autoplayInterval, direction, beforeAutoplay } = this.config;
            if (this.timer) {
                clearInterval(this.timer);
            }
            if (document.hidden) {
                raf.cancel(direction === 'forward' ? this.forwardStep : this.reverseStep);
            }
            else if (autoplay) {
                this.timer = window.setInterval(() => {
                    const { current } = this.state;
                    beforeAutoplay(current, this.props.content.length);
                    raf(direction === 'forward' ? this.forwardStep : this.reverseStep);
                }, autoplayInterval);
            }
        };
        // 自动正向播放
        this.forwardStep = () => {
            const { content } = this.props;
            const { initMove } = this.state;
            let { current } = this.state;
            const { unitSize, padding, autoplaySpeed, afterAutoplay } = this.config;
            let move = this.state.move;
            move += autoplaySpeed;
            this.setState({
                move,
            });
            if (move > initMove + unitSize) {
                raf.cancel(this.forwardStep);
                if (current === this.props.content.length - 1) {
                    current = 0;
                    this.setState({
                        move: unitSize - padding / 2,
                        initMove: unitSize - padding / 2,
                        current,
                    });
                }
                else {
                    ++current;
                    this.setState({
                        move: initMove + unitSize,
                        initMove: initMove + unitSize,
                        current,
                    });
                }
                afterAutoplay(current, content.length);
            }
            else {
                raf(this.forwardStep);
            }
        };
        // 自动反向播放
        this.reverseStep = () => {
            const { content } = this.props;
            const { initMove } = this.state;
            let { current } = this.state;
            const { unitSize, padding, autoplaySpeed, afterAutoplay } = this.config;
            let move = this.state.move;
            move -= autoplaySpeed;
            this.setState({
                move,
            });
            if (move < initMove - unitSize) {
                raf.cancel(this.reverseStep);
                if (current === 0) {
                    current = this.props.content.length - 1;
                    this.setState({
                        move: unitSize * this.props.content.length - padding / 2,
                        initMove: unitSize * this.props.content.length - padding / 2,
                        current,
                    });
                }
                else {
                    --current;
                    this.setState({
                        move: initMove - unitSize,
                        initMove: initMove - unitSize,
                        current,
                    });
                }
                afterAutoplay(current, content.length);
            }
            else {
                raf(this.reverseStep);
            }
        };
        this.handleTouchStart = (e) => {
            if (this.timer) {
                clearInterval(this.timer);
            }
            const { current } = this.state;
            const { touchStart } = this.config;
            touchStart(current, this.props.content.length);
            if (this.props.content.length === 1)
                return;
            const time = new Date();
            this.time0 = time.getTime();
            const touch = e.touches[0];
            this.startX = touch.pageX;
            this.startY = touch.pageY;
            this.moveX = 0;
            this.moveY = 0;
        };
        this.handleTouchMove = (e) => {
            const { initMove, current } = this.state;
            const { touchMove } = this.config;
            touchMove(current, this.props.content.length);
            if (this.props.content.length === 1)
                return;
            const touch = e.touches[0];
            this.moveX = touch.pageX - this.startX;
            this.moveY = touch.pageY - this.startY;
            if (Math.abs(this.moveX) >= Math.abs(this.moveY)) {
                e.preventDefault();
            }
            else if (Math.abs(this.moveX) < Math.abs(this.moveY)) {
                return;
            }
            this.setState({
                move: initMove - this.moveX,
            });
        };
        this.handleTouchEnd = () => {
            const { current } = this.state;
            const { reboundWidth, touchEnd, autoplay, infinite } = this.config;
            touchEnd(current, this.props.content.length);
            if (!this.moveX || this.moveX === 0)
                return;
            if (this.props.content.length === 1)
                return;
            const time = new Date();
            this.time1 = time.getTime();
            const speed = this.time1 - this.time0 > 0 ? (Math.abs(this.moveX) * 1000) / (this.time1 - this.time0) : 0;
            if (Math.abs(this.moveX) >= reboundWidth || speed > 200) {
                if (autoplay || infinite) {
                    raf(this.infiniteStep);
                }
                else {
                    raf(this.step);
                }
            }
            else if (Math.abs(this.moveX) < reboundWidth) {
                raf(this.backStep);
            }
            if (autoplay) {
                const { autoplayInterval, direction, beforeAutoplay } = this.config;
                if (this.timer) {
                    clearInterval(this.timer);
                }
                this.timer = window.setInterval(() => {
                    const { current } = this.state;
                    beforeAutoplay(current, this.props.content.length);
                    raf(direction === 'forward' ? this.forwardStep : this.reverseStep);
                }, autoplayInterval);
            }
        };
        // 回弹动画
        this.backStep = () => {
            const { initMove } = this.state;
            let { move } = this.state;
            const { reboundSpeed } = this.config;
            if (move < initMove) {
                move += reboundSpeed;
            }
            else if (move > initMove) {
                move -= reboundSpeed;
            }
            this.setState({
                move,
            });
            if ((this.moveX >= 0 && move > initMove) || (this.moveX <= 0 && move < initMove)) {
                raf.cancel(this.step);
                this.setState({
                    move: initMove,
                });
            }
            else {
                raf(this.backStep);
            }
        };
        // 非循环滑动动画
        this.step = () => {
            const { initMove } = this.state;
            let { move, current } = this.state;
            const { unitSize, slideSpeed, afterSlide } = this.config;
            if (move < initMove) {
                move -= slideSpeed;
            }
            else if (move > initMove) {
                move += slideSpeed;
            }
            this.setState({
                move,
            });
            if ((this.moveX > 0 && move < initMove - unitSize) || (this.moveX === 0 && move < initMove)) {
                raf.cancel(this.step);
                if (current === 0) {
                    this.setState({
                        move: initMove,
                        initMove,
                        current: 0,
                    });
                }
                else {
                    --current;
                    this.setState({
                        move: initMove - unitSize,
                        initMove: initMove - unitSize,
                        current,
                    });
                }
                afterSlide(current, this.props.content.length);
            }
            else if ((this.moveX < 0 && move > initMove + unitSize) || (this.moveX === 0 && move > initMove)) {
                raf.cancel(this.step);
                if (current === this.props.content.length - 1) {
                    this.setState({
                        move: initMove,
                        initMove,
                        current: this.props.content.length - 1,
                    });
                }
                else {
                    ++current;
                    this.setState({
                        move: initMove + unitSize,
                        initMove: initMove + unitSize,
                        current,
                    });
                }
                afterSlide(current, this.props.content.length);
            }
            else if ((this.moveX > 0 && current === 0) || (this.moveX < 0 && current === this.props.content.length - 1)) {
                raf.cancel(this.step);
                raf(this.backStep);
            }
            else {
                raf(this.step);
            }
        };
        // 循环滑动动画
        this.infiniteStep = () => {
            const { initMove } = this.state;
            let { move, current } = this.state;
            const { unitSize, padding, slideSpeed, afterSlide } = this.config;
            if (move < initMove) {
                move -= slideSpeed;
            }
            else if (move > initMove) {
                move += slideSpeed;
            }
            this.setState({
                move,
            });
            if ((this.moveX > 0 && move < initMove - unitSize) || (this.moveX === 0 && move < initMove)) {
                raf.cancel(this.infiniteStep);
                if (current === 0) {
                    current = this.props.content.length - 1;
                    this.setState({
                        move: unitSize * this.props.content.length - padding / 2,
                        initMove: unitSize * this.props.content.length - padding / 2,
                        current,
                    });
                }
                else {
                    --current;
                    this.setState({
                        move: initMove - unitSize,
                        initMove: initMove - unitSize,
                        current,
                    });
                }
                afterSlide(current, this.props.content.length);
            }
            else if ((this.moveX < 0 && move > initMove + unitSize) || (this.moveX === 0 && move > initMove)) {
                raf.cancel(this.infiniteStep);
                if (current === this.props.content.length - 1) {
                    current = 0;
                    this.setState({
                        move: unitSize - padding / 2,
                        initMove: unitSize - padding / 2,
                        current,
                    });
                }
                else {
                    ++current;
                    this.setState({
                        move: initMove + unitSize,
                        initMove: initMove + unitSize,
                        current,
                    });
                }
                afterSlide(current, this.props.content.length);
            }
            else {
                raf(this.infiniteStep);
            }
        };
        this.setLocation = (translateX) => {
            return typeof window === 'object' && 'WebKitCSSMatrix' in window
                ? `translate3d(${translateX * -1}px, 0, 0)`
                : `translate(-${translateX * -1}px, 0)`;
        };
        this.swiperContainer = React.createRef();
        this.container = React.createRef();
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.swiperContainer.current) {
                this.swiperContainer.current.addEventListener('touchmove', this.handleTouchMove.bind(this), false);
            }
            const { infinite, autoplay, initialSlide } = this.config;
            let { unitSize, padding } = this.config;
            // 非循环模式不支持漂移样式
            if (!infinite) {
                this.config.padding = 0;
                padding = 0;
            }
            if (unitSize === 0 && this.container.current) {
                unitSize =
                    this.config.axis === 'horizonta'
                        ? this.container.current.clientWidth
                        : this.container.current.clientHeight;
                unitSize -= padding;
                this.config.unitSize = unitSize;
            }
            if (this.props.content.length > 0) {
                let len = initialSlide;
                if (autoplay || infinite) {
                    len = initialSlide + 1;
                }
                const initMove = padding === 0 ? unitSize * len : unitSize - padding / 2;
                this.setState({
                    initMove,
                    move: initMove,
                    current: initialSlide,
                }, () => {
                    if (autoplay) {
                        const { autoplayInterval, direction, beforeAutoplay } = this.config;
                        this.timer = window.setInterval(() => {
                            const { current } = this.state;
                            beforeAutoplay(current, this.props.content.length);
                            raf(direction === 'forward' ? this.forwardStep : this.reverseStep);
                        }, autoplayInterval);
                    }
                });
                if (autoplay) {
                    document.addEventListener('visibilitychange', this.handleVisibilityChange);
                }
            }
        });
    }
    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.swiperContainer.current) {
            this.swiperContainer.current.removeEventListener('touchmove', this.handleTouchMove.bind(this));
        }
    }
    render() {
        const { move, current } = this.state;
        const { dots, unitSize, padding, sliderTmpl, dotTmpl, axis, autoplay, infinite } = this.config;
        const content = [...this.props.content];
        if (autoplay || infinite) {
            content.push(content[0]);
            content.splice(0, 0, content[content.length - 2]);
        }
        const swiperWidth = unitSize * content.length;
        const props = {
            style: content.length > 1
                ? Object.assign({ width: swiperWidth }, transform(this.setLocation(move))) : {},
        };
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.swiper_box, ref: this.container },
                React.createElement("div", Object.assign({ className: styles.swiper, ref: this.swiperContainer }, props, { onTouchStart: this.handleTouchStart, onTouchCancel: this.handleTouchEnd, onTouchEnd: this.handleTouchEnd }),
                    React.createElement(List, { content: content, unitSize: unitSize, padding: padding, current: current, tmpl: sliderTmpl, isInfinite: autoplay || infinite, axis: axis }))),
            dots ? React.createElement(Dots, { tmpl: dotTmpl, current: current, total: this.props.content.length }) : ''));
    }
}
Slides.defaultProps = {};
export default Slides;
